import { useEffect, useRef } from "react";
import { ConnectorState } from "./useConnector";

export const useSwitchChain = (
  connector: {
    activate(chainId?: number): Promise<void>;
  },
  state: ConnectorState,
  desiredChainId: number | undefined,
) => {
  const switchingChainsRef = useRef(false);

  useEffect(() => {
    if (
      !state.isActivating &&
      state.isActive &&
      desiredChainId !== undefined &&
      state.chainId !== desiredChainId &&
      !switchingChainsRef.current
    ) {
      switchingChainsRef.current = true;
      connector
        .activate(desiredChainId)
        .catch((e) => {
          console.error(
            state.type +
              " failed to switch chains " +
              state.chainId +
              " " +
              desiredChainId +
              " " +
              e.message,
          );
        })
        .then(() => {
          switchingChainsRef.current = false;
        });
    }
  }, [
    connector,
    state.chainId,
    state.isActivating,
    state.isActive,
    desiredChainId,
  ]);
};
